const initialState = {
  imBusy: true,
}

export default initialState
